"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleCode = void 0;
var LocaleCode;
(function (LocaleCode) {
    LocaleCode["Arabic"] = "ar";
    LocaleCode["ChineseSimplified"] = "zh-CN";
    LocaleCode["ChineseTraditional"] = "zh-TW";
    LocaleCode["English"] = "en";
    LocaleCode["French"] = "fr";
    LocaleCode["German"] = "de";
    LocaleCode["Indonesian"] = "id";
    LocaleCode["Italian"] = "it";
    LocaleCode["Japanese"] = "ja";
    LocaleCode["Korean"] = "ko";
    LocaleCode["Lao"] = "lo";
    LocaleCode["Malay"] = "ms";
    LocaleCode["Portuguese"] = "pt";
    LocaleCode["Russian"] = "ru";
    LocaleCode["Spanish"] = "es";
    LocaleCode["Tagalog"] = "tl";
    LocaleCode["Thai"] = "th";
    LocaleCode["Turkish"] = "tr";
    LocaleCode["Vietnamese"] = "vi";
})(LocaleCode = exports.LocaleCode || (exports.LocaleCode = {}));
